import { jsxs, jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { ChildIcon } from "./child-icon.js";
import '../common/components/logo/logo.css';const Logo = ({
  sjLogoClass = "",
  playLiveLogoClass = "",
  isSmall = false,
  logoAnimationEnabled = false,
  customLogoURL,
  customLogoWidth = 64,
  customLogoHeight = 64,
  customLogoSmallHeight,
  customLogoSmallWidth
}) => {
  const useCustomLogo = useMemo(() => {
    return customLogoURL !== void 0 && customLogoURL !== null && customLogoURL.length > 0;
  }, [customLogoURL]);
  const wrapperClassName = useMemo(() => {
    const classNameParts = ["logo"];
    if (isSmall) classNameParts.push("logo-small");
    if (logoAnimationEnabled) classNameParts.push("logo-animate");
    else classNameParts.push("logo-static");
    if (useCustomLogo) classNameParts.push("logo-custom");
    return classNameParts.join(" ");
  }, [useCustomLogo, isSmall, logoAnimationEnabled]);
  const customLogoClassName = useMemo(() => {
    const classNameParts = ["custom-logo-img"];
    if (isSmall) classNameParts.push("custom-logo-img-small");
    if (logoAnimationEnabled) classNameParts.push("custom-logo-img-animate");
    return classNameParts.join(" ");
  }, [isSmall, logoAnimationEnabled]);
  const logoWidth = useMemo(() => {
    if (isSmall && customLogoSmallWidth === void 0) {
      return customLogoWidth / 2;
    }
    if (isSmall && customLogoSmallWidth !== void 0) {
      return customLogoSmallWidth;
    }
    return customLogoWidth ?? 64;
  }, [customLogoSmallWidth, customLogoWidth, isSmall]);
  const logoHeight = useMemo(() => {
    if (isSmall && customLogoSmallHeight === void 0) {
      return customLogoHeight / 2;
    }
    if (isSmall && customLogoSmallHeight !== void 0) {
      return customLogoSmallHeight;
    }
    return customLogoSmallHeight ?? 64;
  }, [customLogoSmallHeight, customLogoHeight, isSmall]);
  const showChildIcon = useMemo(() => {
    if (useCustomLogo) return logoAnimationEnabled;
    return true;
  }, [useCustomLogo, logoAnimationEnabled]);
  const showPlayLiveLogo = useMemo(() => {
    if (logoAnimationEnabled) return !useCustomLogo;
    return false;
  }, [logoAnimationEnabled, useCustomLogo]);
  return /* @__PURE__ */ jsxs("div", { className: wrapperClassName, children: [
    showChildIcon ? /* @__PURE__ */ jsx(ChildIcon, { className: sjLogoClass }) : null,
    useCustomLogo ? /* @__PURE__ */ jsx(
      "img",
      {
        alt: "Logo",
        className: customLogoClassName,
        height: logoHeight,
        src: customLogoURL,
        width: logoWidth
      }
    ) : null,
    showPlayLiveLogo ? /* @__PURE__ */ jsx(
      "div",
      {
        className: playLiveLogoClass ? `${playLiveLogoClass} playlive_logo` : "playlive_logo",
        children: /* @__PURE__ */ jsx("span", { children: "Play Live logo" })
      }
    ) : null
  ] });
};
export {
  Logo
};
//# sourceMappingURL=logo.js.map
